var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"4.5","cy":"4.5","r":"4.5","fill":"#D9D9D9"}})])}
var staticRenderFns = []

export { render, staticRenderFns }